import { Component, OnInit } from '@angular/core';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchService } from 'src/app/core/services/search.service';

@Component({
  selector: 'app-marketplace-details',
  templateUrl: './marketplace-details.component.html',
  styleUrls: ['./marketplace-details.component.scss'],
})
export class MarketplaceDetailsComponent implements OnInit {
  catalogueId: any;
  apiCatalogFormType: any;
  ApiShow = false;
  
  catalogId: any;
  breadcrumbList = [
    {
      label: 'Dashboard',
      url: '/baseapp/dashboard'
    },
    {
      label: 'Marketplace',
      url: '/baseapp/marketplace'
    },
    {
      label: 'Details',
      url: '/baseapp/marketplace/details'
    }
  ];

  catalogObj: any;
  imagePath: string = "";
  imageLoaded: boolean = false;
  imageId: any;
  catalogStatus: any;
  cartDetails: any;

  loading: boolean = false;
  catalogobjtype: any;
  loader: boolean = true;
  constructor(
    private backendService: BackendService,
    public storage: Storage,
    public helperService: HelperService,
    public searchService: SearchService,
    private route: ActivatedRoute,
    private router: Router
  ) {

  }

  ngOnInit() {
    this.helperService.loader();
    this.getStorage().then((res) => {
      this.catalogId = this.route.snapshot.params['id'];
      this.searchService.sendRouteId(this.catalogId);                 
      this.getApiCatalogDetails(this.catalogId);
      this.catalogueId = this.catalogId;
      this.getCartDetails();
      setTimeout(() => {
        this.helperService.closeLoader();
      }, 1000);   
    })
  }

  getApiCatalogDetails(id) {
    this.loader = true;
    this.getStorage().then((res) => {
      const user_id = res.userId;
      let payload = {
        ID: id
      }
      this.backendService.PostAPICall('getMarketplaceApiCatalogueSource', payload, res.token).subscribe(
        (data) => {
          let res = data[0];
          this.catalogObj = res;
          this.loader = false;
          let bizdata_rest_json = res?.api_input_structure.input?.bizdata_rest;
          //console.log(this.catalogObj.type.name);
          this.catalogobjtype = this.catalogObj.type.name;
          this.apiCatalogFormType = this.catalogobjtype === "Data Source" ? "source" : "target";
          this.imageId = res.api_image;

          if (this.imageId != null) {
            this.getImage(this.imageId);
          }
        },
        (error) => {
          //console.log(error);
          this.helperService.handleError(error);
        }
      );
    })
  }

  getCartDetails() {
    this.getStorage().then((storage) => {
      let payload = {
        user_id: storage.userId
      };
      this.backendService
        .PostAPICall('cartDetails', payload, storage.token)
        .subscribe(
          (data) => {
            if(data) {
              this.cartDetails = data;
              this.searchService.sendCartCount(this.cartDetails.length);
              const catalogEntryExists = this.cartDetails.some((entry) => {
                return entry.ID === parseInt(this.catalogId, 10);
              });
              this.catalogStatus = catalogEntryExists;
            } else {
              this.cartDetails = [];
              this.searchService.sendCartCount(this.cartDetails.length);
              this.catalogStatus = false;
            }
          },
          (error) => {
            //console.log(error);
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          }
        );
    });
  }

  getImage(id) {
    this.getStorage().then((res) => {
      const payload = {
        "img_collection_id": id
      }
      const method = 'post';
      this.backendService.fileUpload('getApiLogoImage', method, payload, res.token).subscribe(
        (data: any) => {
          this.imagePath = 'data:image/jpg;base64,' + data.logo_hash;
          this.imageLoaded = true;
        },
        (error) => {
          //console.log(error);
          this.helperService.handleError(error);
        }
      );
    })
  }

  addToCart (catalogId) {
    this.loader = true;
    this.getStorage().then((res) => {
      let payload = {
        user_id: res.userId,
        catalogue_id: catalogId
      }
      this.backendService.PostAPICall('cart', payload, res.token).subscribe(
        (data) => {
          let cartCount = this.cartDetails.length + 1;
          this.searchService.sendCartCount(cartCount);
          this.catalogStatus = true;
          this.loader = false;
          
        },
        (error) => {
          //console.log(error);
          this.helperService.handleError(error);
        }
      );
    })

  }


  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      showDialog: await this.storage.get("showDialog")
    }
    return data;
  }

  marketplace(){
    this.router.navigate(['baseapp/marketplace'])
  }

}
